/**
 * Session cache for the archive sidebar list (ArchiveUser remounts when switching tabs).
 * Cleared when the user explicitly refreshes the chat list (LiveChat / ChatBar).
 */
const emptyCache = () => ({
  businessId: null,
  data: null,
  hasMore: true,
  page: 1,
  total: null,
});

let cache = emptyCache();

export function getArchiveChatListWarmCache() {
  return cache;
}

export function setArchiveChatListWarmCache(next) {
  cache = { ...emptyCache(), ...next };
}

export function clearArchiveChatListWarmCache() {
  cache = emptyCache();
}
